<template>
  <div>
    <label for="nomeAeroporto" class="required">Nome do Aeroporto:</label>
    <select v-model="selectedAeroporto" @change="enviarEmit" id="aeroporto">
      <option v-for="a in aeroportos" :key="a.id" :value="a.descricao">
        {{ a.descricao }}
      </option>
    </select>
  </div>
</template>
  
<script>
export default {
  name: 'Aeroporto',
  emits: ['aeroporto-selecionado', 'endereco-aeroporto-selecionado'],
  props: {
    aeroporto: { type: String, required: true }
  },

  data() {
    return {
      aeroportos: [],
      selectedAeroporto: this.aeroporto
    };
  },

  watch: {
    selectedAeroporto(newValue) {
      this.selectedAeroporto = newValue;
    },

    aeroporto(newValue) {
      this.selectedAeroporto = newValue;
    }
  },

  methods: {

    async getAeroportos() {
      try {
        const path = '/aeroporto';
        const response = await this.$axios.get(path);
        this.aeroportos = response.data;
      } catch (error) {
        if (error.response) {
          console.error('(buscando aeroportos) Resposta do servidor com status:', error.response.status);
        } else {
          console.error('(buscando aeroportos) Erro sem resposta do servidor:', error.message);
        }
      }

    },

    getEnderecoAeroporto(descricaoBusca) {
      const resultado = this.aeroportos.find(item => item.descricao === descricaoBusca);

      if (resultado) {
        return {
          cep: resultado.cep,
          endereco: resultado.endereco,
          bairro: resultado.bairro,
          numero: resultado.numero,
          cidade: resultado.cidade,
          estado: resultado.uf
        };
      } else {
        return { error: 'Endereço não encontrado' };
      }
    },


    enviarEmit() {
      this.$emit('aeroporto-selecionado', this.selectedAeroporto);
      this.$emit('endereco-aeroporto-selecionado', this.getEnderecoAeroporto(this.selectedAeroporto))
    },
  },

  mounted() {
    this.getAeroportos();
  },

};
</script>
  
<style scoped>
/* Adicione estilos específicos para o componente aqui, se necessário */
</style>